module.exports = __webpack_public_path__ + "img/help-icon.7fd8304a.png";